import React from 'react';
import { observer } from "mobx-react-lite";
import { StringActionDetail } from './components/StringActionDetail';
import { DisplayMode, TranslatedStringActionDetail } from './components/TranslatedStringActionDetail';
import { BooleanActionDetail } from './components/BooleanActionDetail';
import { editorStore } from '../../../stores/EditorStore';
import { useTranslation } from 'react-i18next';
export const ReceiveQuestActionDetails = observer(({
  action
}) => {
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(StringActionDetail, {
    name: t("action_editor.property_quest_id"),
    value: action.questId,
    valueSetter: action.setQuestId.bind(action),
    allowBlankValue: false
  }), /*#__PURE__*/React.createElement(TranslatedStringActionDetail, {
    name: t("action_editor.property_description"),
    translatedString: action.description,
    displayMode: DisplayMode.CommentAndGenders,
    allowBlankValue: false
  }), editorStore.isMainGameEditor && /*#__PURE__*/React.createElement(BooleanActionDetail, {
    name: t("action_editor.property_scope_global"),
    checked: action.global,
    toggle: action.toggleGlobal.bind(action)
  }));
});